
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.462.308a4.391 4.391 0 00-4.378 4.377 4.378 4.378 0 001.901 3.599 4.54 4.54 0 00-1.647 1.165C.452 10.456.03 11.845.03 13.397v4.086l.579.238c.145.058.313.097.5.097h8.704c.188 0 .355-.037.5-.097l.58-.238v-4.086c0-1.552-.422-2.94-1.308-3.948A4.54 4.54 0 007.94 8.284a4.379 4.379 0 001.9-3.599A4.392 4.392 0 005.461.308zm0 1.876c1.392 0 2.501 1.11 2.501 2.501s-1.11 2.502-2.502 2.502S2.96 6.077 2.96 4.685s1.11-2.501 2.502-2.501zm0 7.504c1.448 0 2.213.432 2.714 1 .512.581.84 1.497.84 2.709v2.545h-7.11v-2.545c0-1.212.33-2.126.841-2.71.5-.567 1.266-.999 2.714-.999z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M15.155 4.998a.938.938 0 00-1.876 0v1.876h-1.876a.938.938 0 000 1.876h1.876v1.876a.938.938 0 001.876 0V8.75h1.876a.938.938 0 000-1.876h-1.876z","clip-rule":"evenodd"}})])
          )
        }
      }
    